import {
    DELIVERY_CHALLAN_REGISTER_RETURN_GRAY_REPORT_REQUEST,
    DELIVERY_CHALLAN_REGISTER_RETURN_GRAY_REPORT_SUCCESS,
    DELIVERY_CHALLAN_REGISTER_RETURN_GRAY_REPORT_FAILURE,
    DELIVERY_CHALLAN_REGISTER_RETURN_GRAY_FILTER_REPORT_REQUEST,
    DELIVERY_CHALLAN_REGISTER_RETURN_GRAY_FILTER_REPORT_SUCCESS,
    DELIVERY_CHALLAN_REGISTER_RETURN_GRAY_FILTER_REPORT_FAILURE
  } from "../types/delivery-challan-register-return-gray-report-types";
  
  const initialState = {
    deliveryChallanReturnGrayReports: {},
    loading: false,
    error: null,
  };
  
  const deliveryChallanReturnGrayReportReducer = (state = initialState, action) => {
    switch (action.type) {
      case DELIVERY_CHALLAN_REGISTER_RETURN_GRAY_REPORT_REQUEST, DELIVERY_CHALLAN_REGISTER_RETURN_GRAY_FILTER_REPORT_REQUEST: {
        return {
          ...state,
          loading: true,
          error: null
        };
      }
      case DELIVERY_CHALLAN_REGISTER_RETURN_GRAY_REPORT_SUCCESS: {
        return {
          ...state,
          deliveryChallanRegisterReturnGrayReport: {...(action.payload || {})},
          loading: false,
          error: null
        };
      }
      case DELIVERY_CHALLAN_REGISTER_RETURN_GRAY_FILTER_REPORT_SUCCESS: {
        return {
          ...state,
          deliveryChallanRegisterReturnGrayFilterReport: {...(action.payload || {})},
          loading: false,
          error: null
        };
      }
      case DELIVERY_CHALLAN_REGISTER_RETURN_GRAY_REPORT_FAILURE, DELIVERY_CHALLAN_REGISTER_RETURN_GRAY_FILTER_REPORT_FAILURE: {
        return {
          ...state,
          loading: false,
          error: action.error
        };
      }
      default:
        return state;
    }
  };
  
  export default deliveryChallanReturnGrayReportReducer;
  